import { paraphraseColors, paraphraseProgress, ParaphraseType } from '@pages/Paraphrase'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sessionId: null,
  progress: paraphraseProgress,
  currentProgress: paraphraseProgress[0],
  type: ParaphraseType.ENTER_SENTENCE,
  currentSentence: null,
  originSentence: null,
  isFirstTime: false,
  colorsParaphrase: paraphraseColors,
  footerData: null,
  isLoading: false,
  paraphraseData: null,
  currentIndexDragDropData: 0,
  dragDropDataLength: 0,
  isShowFooter: false,
  audio: {},
  isFinish: false,
  isCorrectGrammars: false,
}

export const paraphraseSlice = createSlice({
  name: 'paraphrase',
  initialState,
  reducers: {
    updateProgress: (state, action) => {
      state.progress = action.payload
    },
    updateCurrentProgress: (state, action) => {
      state.currentProgress = action.payload
    },
    updateType: (state, action) => {
      state.type = action.payload
    },
    updateCurrentSentence: (state, action) => {
      state.currentSentence = action.payload
    },
    updateOriginSentence: (state, action) => {
      state.originSentence = action.payload
    },
    updateSessionId: (state, action) => {
      state.sessionId = action.payload
    },
    updateIsFirstTime: (state, action) => {
      state.isFirstTime = action.payload
    },
    updateFooterData: (state, action) => {
      state.footerData = action.payload
    },
    updateIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    updateParaphraseData: (state, action) => {
      state.paraphraseData = action.payload
    },
    updateCurrentIndexDragDropData: (state, action) => {
      state.currentIndexDragDropData = action.payload
    },
    updateDragDropDataLength: (state, action) => {
      state.dragDropDataLength = action.payload
    },
    updateIsShowFooter: (state, action) => {
      state.isShowFooter = action.payload
    },
    updateAudio: (state, action) => {
      state.audio = action.payload
    },
    updateIsFinish: (state, action) => {
      state.isFinish = action.payload
    },
    updateIsCorrectGrammars: (state, action) => {
      state.isCorrectGrammars = action.payload
    },
    reset: state => {
      return Object.assign(state, {
        ...initialState
      })
    },
  },
})

export const {
  updateProgress,
  updateCurrentProgress,
  updateType,
  updateCurrentSentence,
  updateOriginSentence,
  updateSessionId,
  updateIsFirstTime,
  updateFooterData,
  updateIsLoading,
  updateParaphraseData,
  updateCurrentIndexDragDropData,
  updateDragDropDataLength,
  updateIsShowFooter,
  updateAudio,
  updateIsFinish,
  updateIsCorrectGrammars,
  reset,
} = paraphraseSlice.actions

export default paraphraseSlice.reducer
